import moment from "moment";
const currentDate = moment().format("DD-MM-YYYY");

export default {
    address: "",
    assigned_manager: "",
    assigned_operatives: [],
    assigned_supervisor: "",
    client_name: "",
    attached_files: [],
    description_of_works: "",
    end_date: currentDate,
    job_id: "",
    job_name: "",
    job_type: "",
    location_lat: "",
    location_long: "",
    start_date: currentDate,
    status: "active",
    calendar_color: "",
    sswp_config_uid: "",
    master_sswp_v1: "Yes",
    tm_plan: "Yes",
    tm_slg_checklist: "Yes",
    vehicle_checklist: "Yes"
};
